/**
 * FOOTRA Theme Core JavaScript
 * Modern Vanilla JS interactions
 */

document.addEventListener('DOMContentLoaded', () => {
  initStickyHeader();
  initSearchDrawer();
  initModals();
  initPDPGallery();
  initPDPVariantSelectors();
  initAccordions();
  initStickyATC();
});

/* Sticky Glassmorphism Header */
function initStickyHeader() {
  const header = document.querySelector('.site-header');
  if (!header) return;

  const handleScroll = () => {
    if (window.scrollY > 20) {
      header.classList.add('scrolled');
    } else {
      header.classList.remove('scrolled');
    }
  };

  window.addEventListener('scroll', handleScroll, { passive: true });
  handleScroll();
}

/* Live Search Drawer */
function initSearchDrawer() {
  const searchTriggers = document.querySelectorAll('[data-search-trigger]');
  const searchOverlay = document.querySelector('.search-drawer-overlay');
  const searchClose = document.querySelectorAll('[data-search-close]');
  const searchInput = document.querySelector('.search-input-field');

  if (!searchOverlay) return;

  const openSearch = (e) => {
    e?.preventDefault();
    searchOverlay.classList.add('active');
    document.body.style.overflow = 'hidden';
    setTimeout(() => searchInput?.focus(), 150);
  };

  const closeSearch = () => {
    searchOverlay.classList.remove('active');
    document.body.style.overflow = '';
  };

  searchTriggers.forEach(btn => btn.addEventListener('click', openSearch));
  searchClose.forEach(btn => btn.addEventListener('click', closeSearch));

  searchOverlay.addEventListener('click', (e) => {
    if (e.target === searchOverlay) closeSearch();
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && searchOverlay.classList.contains('active')) {
      closeSearch();
    }
  });

  if (searchInput) {
    searchInput.addEventListener('input', (e) => {
      const q = e.target.value.toLowerCase().trim();
      const results = document.querySelectorAll('.search-result-card');
      results.forEach(card => {
        const text = card.textContent.toLowerCase();
        if (!q || text.includes(q)) {
          card.style.display = 'flex';
        } else {
          card.style.display = 'none';
        }
      });
    });
  }
}

/* Modals (Size Chart) */
function initModals() {
  const triggers = document.querySelectorAll('[data-modal-target]');
  const closeBtns = document.querySelectorAll('[data-modal-close]');

  triggers.forEach(trigger => {
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      const targetId = trigger.getAttribute('data-modal-target');
      const modal = document.querySelector(targetId);
      if (modal) {
        modal.classList.add('active');
        document.body.style.overflow = 'hidden';
      }
    });
  });

  closeBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      const modal = btn.closest('.modal-overlay');
      if (modal) {
        modal.classList.remove('active');
        document.body.style.overflow = '';
      }
    });
  });

  document.querySelectorAll('.modal-overlay').forEach(modal => {
    modal.addEventListener('click', (e) => {
      if (e.target === modal) {
        modal.classList.remove('active');
        document.body.style.overflow = '';
      }
    });
  });
}

/* PDP Multi-Media Gallery */
function initPDPGallery() {
  const mainImage = document.querySelector('[data-pdp-main-image]');
  const thumbnails = document.querySelectorAll('[data-pdp-thumbnail]');
  if (!mainImage || !thumbnails.length) return;

  thumbnails.forEach(thumb => {
    thumb.addEventListener('click', () => {
      thumbnails.forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
      const newSrc = thumb.getAttribute('data-full-src');
      if (newSrc) {
        mainImage.src = newSrc;
      }
    });
  });
}

/* PDP Variant Selectors */
function initPDPVariantSelectors() {
  const colorSwatches = document.querySelectorAll('.color-swatch-btn');
  const selectedColorLabel = document.querySelector('[data-selected-color]');

  colorSwatches.forEach(swatch => {
    swatch.addEventListener('click', () => {
      colorSwatches.forEach(s => s.classList.remove('selected'));
      swatch.classList.add('selected');
      const color = swatch.getAttribute('data-color');
      if (selectedColorLabel && color) {
        selectedColorLabel.textContent = color;
      }
      const imageSrc = swatch.getAttribute('data-variant-image');
      const mainImage = document.querySelector('[data-pdp-main-image]');
      if (imageSrc && mainImage) {
        mainImage.src = imageSrc;
      }
    });
  });

  const sizePills = document.querySelectorAll('.size-pill-btn');
  const selectedSizeLabel = document.querySelector('[data-selected-size]');
  const stickySizeLabel = document.querySelector('[data-sticky-size]');

  sizePills.forEach(pill => {
    pill.addEventListener('click', () => {
      sizePills.forEach(p => p.classList.remove('selected'));
      pill.classList.add('selected');
      const size = pill.getAttribute('data-size');
      if (selectedSizeLabel && size) {
        selectedSizeLabel.textContent = size;
      }
      if (stickySizeLabel && size) {
        stickySizeLabel.textContent = size;
      }
    });
  });
}

/* Collapsible Accordions */
function initAccordions() {
  const headers = document.querySelectorAll('.accordion-header');
  headers.forEach(header => {
    header.addEventListener('click', () => {
      const item = header.closest('.accordion-item');
      if (!item) return;
      const isOpen = item.classList.contains('active');
      item.classList.toggle('active', !isOpen);
    });
  });
}

/* Sticky Add-to-Cart Bar */
function initStickyATC() {
  const stickyBar = document.querySelector('.sticky-atc-bar');
  const mainBuyForm = document.querySelector('#pdp-buy-form');
  if (!stickyBar || !mainBuyForm) return;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (!entry.isIntersecting && entry.boundingClientRect.top < 0) {
        stickyBar.classList.add('visible');
      } else {
        stickyBar.classList.remove('visible');
      }
    });
  }, { threshold: 0.1 });

  observer.observe(mainBuyForm);

  const stickyBtn = document.querySelector('#sticky-atc-button');
  if (stickyBtn) {
    stickyBtn.addEventListener('click', () => {
      const submitBtn = mainBuyForm.querySelector('[type="submit"]');
      if (submitBtn) {
        submitBtn.click();
      } else {
        mainBuyForm.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
      }
    });
  }
}
